import * as React from 'react';
import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ICreateAction } from './interfaces';

export const CreateAction: React.FC<ICreateAction> = ({
  onClick,
}): JSX.Element => {
  return (
    <Fab color="primary" onClick={onClick}>
      <AddIcon />
    </Fab>
  );
};
